
  <div [class.dropup]="direction === 'up'"
  [class.dropdown]="direction === 'down'"
  [class.show]="isOpen"
  [class.open]="isOpen">
    <ng-content></ng-content>
  </div>
  


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/dropdown/dropdown-container.component.ts.BsDropdownContainerComponent.html